import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { B2BService } from 'src/app/b2-b.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ManagementComponent } from '../management.component';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {

 constructor(public parent: ManagementComponent, private B2BService:B2BService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router) {
 
     translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
     translate.setDefaultLang('en');
 
     const browserLang = this.parent.getLanguage();
     translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');
 
      // Debounce search.
      this.partnerSearchTermUpdate.pipe(
       debounceTime(200),
       distinctUntilChanged())
       .subscribe(value => {
         if(value?.length >= 1){
           this.Filter.SearchTerm = value;
           this.GetPartnersFiltered();
         }
       });
    }
 
    partnerSearchTermUpdate = new Subject<string>();
    agentSearchTermUpdate = new Subject<string>();

    searchTerm:string
    roleID:number;
    users:any[];
    loadingUser:boolean;
    masterData:any;
    lastSelected:boolean;
    AppAccessApplications:any[];

    // Custom UI state for iOS-style controls
    ShowUserDetailPopup:boolean = false;
    selectedUserForPopup:any = null;
    expandedUserId:string = null;
    showMainRoleDropdown:boolean = false;
    showUrlAccessDropdown:boolean = false;
    showAppAccessDropdown:boolean = false;
    showAgentDropdownInDialog:boolean = false;
    companyRoleDropdowns:any = {};
    companyDeptDropdowns:any = {};
 
    URLs:any[];
 
   ngOnInit(): void {
     this.GetUsersFiltered();
     this.GetURLs();
     this.InitializeFilter();
     this.GetCompanyAgents();
 
     document.addEventListener('DOMNodeInserted', function () {
       const elements = document.querySelectorAll('[aria-owns]');
 
       elements.forEach(element => {
         element.removeAttribute('aria-owns');
       });
     });
   }
 
   Agents:any[];
 
   GetCompanyAgents(){
 
     var request = {
       User:this.parent.User,
       Language:this.parent.getLanguage(),
       CompanyID:this.parent.Company.ID
     };
 
     this.loadingUser = true;
 
     this.service.GetCompanyAgents(request).subscribe(response => {
    
       if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
       }
       else if(response["Status"] == 1){
         this.Agents = response["Agents"];
       }
    
       this.loadingUser = false;
     });
   }
 
   GetURLs(){
 
     var request = {
       User:this.parent.User,
       Language:this.parent.getLanguage(),
     };
 
     this.loadingUser = true;
 
     this.service.GetURLs(request).subscribe(response => {
    
       if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
       }
       else if(response["Status"] == 1){
         this.URLs = response["URLs"];
       }
    
       this.loadingUser = false;
     });
   }
 
   GetUsersFiltered(){
     
     var request = {
       User:this.parent.User,
       Language:this.parent.getLanguage(),
       SearchTerm:this.searchTerm,
       RoleID:this.roleID
     };
 
     this.parent.loading = true;
 
     this.service.GetUsersFiltered(request).subscribe(response => {
    
       if(response["Status"] != 1){
         
       }
       else if(response["Status"] == 1){
         this.users = response["Users"];
       }
    
       this.parent.loading = false;
     });
 
   }
 
   GetUser(user:any){
 
     var request = {
       User:this.parent.User,
       Language:this.parent.getLanguage(),
       id:user.Id,
       WithDetails:true,
     };
 
     this.loadingUser = true;
 
     this.service.GetUser(request).subscribe(response => {
    
       if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
       }
       else if(response["Status"] == 1){
 
         this.users.forEach(u => {
       
           if(u.Id == response["User"].Id){
             u.Rights = response["User"].Rights;
             u.AppAccess = response["User"].AppAccess;
             u.B2BSettings = response["User"].B2BSettings;
             u.IsSelected = true;
 
             this.AppAccessApplications = [];
             response["User"].AppAccess.forEach(a => {
               this.AppAccessApplications.push(a.Application);
             });
           }
           else{
             u.IsSelected = false;
           }
          
         });
 
         this.GetUserUnassignedCompanies(user);
         this.ProofB2BAccess(user);
         this.GetB2BUserConnectedPartner(user);
         this.GetB2BUserConnectedAgent(user);
       }
    
       this.loadingUser = false;
     });
   }
 
   compareFn(c1: any, c2: any): boolean {
     return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
 }
 
 compareMultipleFn(o1: any, o2: any): boolean {
   
    // if possible compare by object's name property - and not by reference.
    return o1 && o2 ? o1.ID === o2.ID : o2 === o2;
 }
 
 compareMultipleFnAppAccess(o1: any, o2: any): boolean {
   
   // if possible compare by object's name property - and not by reference.
   return o1 && o2 ? o1.ID === o2.ID && o2.Access == true : o2 === o2;
 }
 
 ChangingCompanyID:number;
 
 UpdateUserRights(u:any){
 
   var request = {
     Id:u.Id,
     Rights:u.Rights,
     ChangingCompanyID:this.ChangingCompanyID,
     Language:this.parent.getLanguage(),
     User:this.parent.User
   };
 
   this.loadingUser = true;
 
     this.service.UpdateUserRights(request).subscribe(response => {
    
       if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
       }
       else if(response["Status"] == 1){
       }
    
       this.loadingUser = false;
     });
 }
 
 changeUrlAccess(event){
   this.lastSelected = event.source._selected;
 }
 
 lastAppAccessSelected:boolean;
 
 changeAppAccess(event){
   this.lastAppAccessSelected = event.source._selected;
 }
 
 UpdateUserURLAccess(url:any, userID:string){
 
   var request = {
     Language:this.parent.getLanguage(),
     User:this.parent.User,
     URL:url,
     UserID:userID,
     Access:this.lastSelected
   };
 
   this.service.UpdateUserURLAccess(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
     }
   });
 }
 
 AppAccess:any;
 ShowGrantAllURLsAccess:boolean;
 
 AddUpdateUserAppAccess(App:any){
 
   App.Access = this.lastAppAccessSelected;
 
   var AppAccess = {
     ID:0,
     Application:null,
     UserID:null,
     Access:this.lastAppAccessSelected
   };
 
   this.users.forEach(u => {
     if(u.IsSelected){
       u.AppAccess.forEach(a => {
         if(a.Application.ID == App.ID){
           a.Access = this.lastAppAccessSelected;
           AppAccess = a;
         }
       });
     }
   });
 
   if(AppAccess?.ID == 0){
     AppAccess.Application = App;
     
     this.users.forEach(u => {
       if(u.IsSelected){
         AppAccess.UserID = u.Id;
       }
     });
   }
 
   AppAccess.Application.Access = this.lastAppAccessSelected;
 
   var request = {
     Language:this.parent.getLanguage(),
     User:this.parent.User,
     AppAccess:AppAccess
   };
 
   this.service.AddUpdateUserAppAccess(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
 
       var u = {
         Id:AppAccess.UserID
       }
 
       this.GetUser(u);
       this.AppAccess = AppAccess;
       this.ShowGrantAllURLsAccess = true;
     }
   });
 }
 
 GetUserUnassignedCompanies(user:any){
 
   var request = {
     User:user,
     Language:this.parent.getLanguage(),
   };
 
   this.loadingUser = true;
 
   this.service.GetUserUnassignedCompanies(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.users.forEach(u => {
       
         if(u.Id == user.Id){
           var companies = response["Companies"];
           u.Rights.AssignedCompanies = u.Rights.AssignedCompanies.concat(companies);          
         }
        
       });
     }
  
     this.loadingUser = false;
   });
 }
 
 checkOption(event) {
   // this prevents the click event to get to the autocomplete component
   event.stopPropagation();
 }
 
 UpdateB2BSearchPriceAPIAccess(u:any, UpdateB2BSearchPriceAPIAccess:boolean){
   u.B2BSettings.B2BSearchPriceAPIAccess = UpdateB2BSearchPriceAPIAccess;
 
   var request = {
     User:u,
     Language:this.parent.getLanguage(),
   };
 
   this.loadingUser = true;
 
   this.service.UpdateUser(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
     }
  
     this.loadingUser = false;
   });
 }
 
 AddUpdatePartnerB2BSettings(CanDownloadPriceLists:boolean){
 
   var bsettings = JSON.parse(JSON.stringify(this.B2BPartner.B2BSettings));
   bsettings.CanDownloadPriceLists = JSON.parse(JSON.stringify(!CanDownloadPriceLists));
 
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     B2BSettings:bsettings
   };
 
   this.loadingUser = true;
 
   this.service.AddUpdatePartnerB2BSettings(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
     }
  
     this.loadingUser = false;
   });
 }
 
 EnableDisableUser(UserID:string, Disabled:boolean){
 
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     UserID:UserID,
     Disabled:Disabled
   };
 
   this.loadingUser = true;
 
   this.service.EnableDisableUser(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
     }
  
     this.loadingUser = false;
   });
 }
 
 GrantUserAppUrlsAccess(AppAccess:any){
 
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     UserID:AppAccess.UserID,
     Application:AppAccess.Application
   };
 
   this.ShowGrantAllURLsAccess = false;
   this.loadingUser = true;
 
   this.service.GrantUserAppUrlsAccess(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");

       var selectedUser = this.users.find(u => u.IsSelected == true);
       if(selectedUser){
         this.GetUser(selectedUser);
       }
     }

     this.loadingUser = false;
   });
 }
 
 UserHasB2BAccess:boolean = false;
 
 ProofB2BAccess(user:any){
 
   this.UserHasB2BAccess = false;
 
  user.AppAccess.forEach(AppAccess => {
   if(AppAccess.Application.Name == "B2B"){
     if(AppAccess.Application.Access ==  true){
       this.UserHasB2BAccess = true;
     }
   }
  });
 }
 
 PartnerSelectContainer:boolean = false;
 B2BPartner:any = null;
 SelectedPartnerInModal:any = null;

 OpenPartnerSelectContainer(){
   this.SelectedPartnerInModal = null;
   this.PartnerSelectContainer = true;

   if(this.B2BPartner?.Name?.length > 0){
     this.Filter.SearchTerm = this.B2BPartner.Name;
   }
 }

 ClosePartnerSelectContainer(){
   this.PartnerSelectContainer = false;
   this.SelectedPartnerInModal = null;
 }

 SelectPartnerInModal(partner:any){
   this.SelectedPartnerInModal = partner;
   this.Filter.SearchTerm = partner.Name;
 }

 ConfirmSelectedPartner(){
   if(this.SelectedPartnerInModal){
     this.B2BPartner = this.SelectedPartnerInModal;
     this.SelectedPartnerInModal = null;
     this.AddUpdateB2BUserPartnerConnection();
   }
 }
 
 GetB2BUserConnectedPartner(user:any){
 
   var request = {
     User:user,
     Language:this.parent.getLanguage(),
   };
 
   this.loadingUser = true;
 
   this.B2BService.GetB2BUserConnectedPartner(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.B2BPartner = response["Partner"];
       this.ProofUserB2BData(user, this.B2BPartner);
     }
  
     this.loadingUser = false;
   });
 }
 
 AgentSelectContainer:boolean = false;
 B2BAgent:any = null;
 
 OpenAgentSelectContainer(){
   this.AgentSelectContainer = true;
 
   if(this.B2BAgent?.Name?.length > 0){
     this.Filter.SearchTerm = this.B2BAgent.Name;
   }
 }
 
 GetB2BUserConnectedAgent(user:any){
 
   var request = {
     User:user,
     Language:this.parent.getLanguage(),
   };
 
   this.loadingUser = true;
 
   this.B2BService.GetB2BUserConnectedAgent(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.B2BAgent = response["Agent"];
     }
  
     this.loadingUser = false;
   });
 }
 
 Partners = [];
 Filter: {[k: string]: any} = {};
 
 InitializeFilter(){
 
   this.Filter = {};
   this.Filter.SearchTerm = "";
 
   this.Filter.Pager = {};
   this.Filter.Pager.PageIndex = 1;
   this.Filter.Pager.PageSize = 50;
   this.Filter.Pager.TotalCount = 0;
 
   this.Filter.Company = {};
   this.Filter.Company = null;
 
   this.Filter.Brand = {};
   this.Filter.Brand = null;
 
   this.Filter.ProductBoxStatus = {};
   this.Filter.ProductBoxStatus = null;
 
   this.Filter.ProductConditionStatus = {};
   this.Filter.ProductConditionStatus = null;
 
   this.Filter.ProductManufacturingStatus = {};
   this.Filter.ProductManufacturingStatus = null;
 
   this.Filter.ProductVersionStatus = {};
   this.Filter.ProductVersionStatus = null;
 
   this.Filter.Creator = {};
   this.Filter.Creator = null;
 
   this.Filter.Updater = {};
   this.Filter.Updater = null;
 }
 
 GetPartnersFiltered(){
   var request = {
     SearchTerm:this.Filter.SearchTerm,
     CountryID:this.Filter.Country?.ID,
     PageIndex:this.Filter.Pager.PageIndex,
     PageSize:this.Filter.Pager?.PageSize,
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     CompanyID:this.Filter.Company?.ID
   };
 
   this.service.GetPartnersFiltered(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
      this.Partners = response["Partners"];
      this.Filter.Pager.TotalCount = response["Count"];
     }
  
   });
 }
 
 AddUpdateB2BUserPartnerConnection(){
  
   var UserID;
 
   this.users.forEach(u => {
     if(u.IsSelected == true){
       UserID = u.Id;
     }
   });
 
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     PartnerID:this.B2BPartner.ID,
     UserID:UserID
   };
 
   this.B2BService.AddUpdateB2BUserPartnerConnection(request).subscribe(response => {

     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");

       // Re-fetch full user details (chains all 5 endpoints)
       var selectedUser = this.users.find(u => u.IsSelected == true);
       if(selectedUser){
         this.GetUser(selectedUser);
       }
     }

     this.PartnerSelectContainer = false;
   });
 }
 
 AddUpdateB2BUserAgentConnection(){
  
   var UserID;
 
   this.users.forEach(u => {
     if(u.IsSelected == true){
       UserID = u.Id;
     }
   });
 
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     AgentID:this.B2BAgent.ID,
     UserID:UserID
   };
 
   this.B2BService.AddUpdateB2BUserAgentConnection(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.AgentSelectContainer = false;
     }
  
   });
 }
 
 DeallocateB2BUserAgentConnection(){
  
   var UserID;
 
   this.users.forEach(u => {
     if(u.IsSelected == true){
       UserID = u.Id;
     }
   });
 
   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     AgentID:this.B2BAgent.ID,
     UserID:UserID
   };
 
   this.B2BService.DeallocateB2BUserAgentConnection(request).subscribe(response => {
  
     if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       this.B2BAgent = null;
     }
  
   });
 }
 
 SelectB2BAgent(a:any){
   this.B2BAgent = a;
 }

 ClearSelectedPartner(){
   this.B2BPartner = null;
   this.Filter.SearchTerm = "";
   this.Partners = [];
 }
 
 ShowB2BAgentDeallocation:boolean = false;
 
 PrepareB2BAgentDeallocation(){
   this.ShowB2BAgentDeallocation = true;
 }
 
 ProofUserB2BData(user:any, partner:any){

   var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     TestedUserID:user.Id,
     B2BPartner:partner
   };

   this.B2BService.ProofUserB2BData(request).subscribe(response => {

     if(response["Status"] != 1){
       var errors = response["Errors"];

       this.users.forEach(u => {
         if(u.IsSelected == true){
           u.Rights.AccessErrors = u.Rights.AccessErrors.concat(errors);
         }
       });
     }
     else if(response["Status"] == 1){
     }

   });
 }

 // Custom iOS UI helpers
 toggleUserPanel(user:any){
   this.selectedUserForPopup = user;
   this.ShowUserDetailPopup = true;
   this.closeAllDropdowns();
   this.GetUser(user);
 }

 CloseUserDetailPopup(){
   this.ShowUserDetailPopup = false;
   this.selectedUserForPopup = null;
   this.closeAllDropdowns();
 }

 isUserExpanded(user:any):boolean{
   return this.expandedUserId === user.Id;
 }

 closeAllDropdowns(){
   this.showMainRoleDropdown = false;
   this.showUrlAccessDropdown = false;
   this.showAppAccessDropdown = false;
   this.showAgentDropdownInDialog = false;
   this.companyRoleDropdowns = {};
   this.companyDeptDropdowns = {};
 }

 isUrlSelected(url:any, user:any):boolean{
   if(!user?.Rights?.URLs) return false;
   return user.Rights.URLs.some((u:any) => u.ID === url.ID);
 }

 toggleUrlAccess(url:any, user:any){
   var isCurrentlySelected = this.isUrlSelected(url, user);
   this.lastSelected = !isCurrentlySelected;

   if(isCurrentlySelected){
     user.Rights.URLs = user.Rights.URLs.filter((u:any) => u.ID !== url.ID);
   } else {
     user.Rights.URLs.push(url);
   }

   this.UpdateUserURLAccess(url, user.Id);
 }

 isAppAccessSelected(app:any):boolean{
   if(!this.AppAccessApplications) return false;
   return this.AppAccessApplications.some((a:any) => a.ID === app.ID && a.Access === true);
 }

 toggleAppAccessCustom(app:any){
   var isCurrentlySelected = this.isAppAccessSelected(app);
   this.lastAppAccessSelected = !isCurrentlySelected;
   this.AddUpdateUserAppAccess(app);
 }

 selectCompanyRole(role:any, company:any, user:any){
   this.ChangingCompanyID = company.ID;
   company.MainRole = role;
   this.UpdateUserRights(user);
   this.companyRoleDropdowns[company.ID] = false;
 }

 selectCompanyDept(dept:any, company:any, user:any){
   this.ChangingCompanyID = company.ID;
   company.Department = dept;
   this.UpdateUserRights(user);
   this.companyDeptDropdowns[company.ID] = false;
 }

 selectMainRole(role:any, user:any){
   user.Rights.MainRole = role;
   this.UpdateUserRights(user);
   this.showMainRoleDropdown = false;
 }

 selectAgentInDialog(agent:any){
   this.B2BAgent = agent;
   this.showAgentDropdownInDialog = false;
 }

}
